import { motion } from "framer-motion";
import { Check, X, Star, MapPin, Layers } from "lucide-react";
import { COMPARAISON_CARDS, SITE } from "../../data/site";
import { Reveal, SectionHeading } from "./Reveal";
import { LogoMark } from "./Logo";
import { handleSpotlight } from "../../lib/spotlight";

export const Comparatif = () => (
  <section id="comparatif" data-testid="comparatif-section" className="relative py-24 sm:py-32 bg-[#F8F9FA] overflow-hidden">
    <div className="glow-blob absolute -top-24 -left-32 w-[440px] h-[440px] rounded-full bg-violet-200/40" />
    <div className="glow-blob absolute top-1/4 right-0 w-[420px] h-[420px] rounded-full bg-purple-200/45" />
    <div className="relative max-w-5xl mx-auto px-5 sm:px-8">
      <SectionHeading
        center
        label="Pourquoi nous choisir"
        title="La différence Bestconduite78"
        description="Une méthode éprouvée, un suivi personnalisé et des formations certifiées."
      />

      <div className="grid md:grid-cols-2 gap-6 mt-14">
        <Reveal delay={0.05} className="h-full">
          <motion.div
            whileHover={{ y: -5 }}
            transition={{ duration: 0.25 }}
            onMouseMove={handleSpotlight}
            data-testid="comparatif-card-best"
            className="spotlight h-full rounded-2xl bg-white border border-violet-200 shadow-[0_20px_60px_rgb(109,40,217,0.10)] p-7 sm:p-9"
          >
            <div className="flex items-center gap-3.5">
              <LogoMark size={44} />
              <h3 className="font-heading font-extrabold text-slate-900 text-xl sm:text-2xl tracking-tight">Best Conduite</h3>
            </div>
            <div className="h-px bg-violet-100 my-6" />
            <ul className="space-y-5">
              {COMPARAISON_CARDS.ours.map((item) => (
                <li key={item} className="flex items-start gap-3.5 text-[15px] font-semibold text-slate-700">
                  <Check size={20} strokeWidth={2.5} className="text-violet-700 shrink-0 mt-0.5" />
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        </Reveal>

        <Reveal delay={0.12} className="h-full">
          <motion.div
            whileHover={{ y: -5 }}
            transition={{ duration: 0.25 }}
            onMouseMove={handleSpotlight}
            data-testid="comparatif-card-autres"
            className="spotlight h-full rounded-2xl bg-white border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-7 sm:p-9"
          >
            <div className="flex items-center gap-3.5">
              <div className="w-11 h-11 rounded-xl bg-slate-100 flex items-center justify-center">
                <Layers size={20} className="text-slate-500" />
              </div>
              <h3 className="font-heading font-extrabold text-slate-900 text-xl sm:text-2xl tracking-tight">Autres</h3>
            </div>
            <div className="h-px bg-slate-100 my-6" />
            <ul className="space-y-5">
              {COMPARAISON_CARDS.others.map((item) => (
                <li key={item} className="flex items-start gap-3.5 text-[15px] font-medium text-slate-500">
                  <X size={20} strokeWidth={2.5} className="text-slate-400 shrink-0 mt-0.5" />
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mt-6">
        <Reveal delay={0.1} className="h-full">
          <motion.a
            href={SITE.googleUrl}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ y: -5 }}
            transition={{ duration: 0.25 }}
            data-testid="comparatif-google-card"
            className="block h-full rounded-2xl bg-gradient-to-br from-violet-700 to-violet-900 text-white p-7 shadow-[0_20px_60px_rgb(109,40,217,0.25)]"
          >
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={17} className="fill-amber-300 text-amber-300" />
              ))}
            </div>
            <p className="font-heading font-black text-4xl mt-4">5/5</p>
            <p className="text-violet-200 text-sm mt-2 leading-relaxed">
              Note moyenne de nos élèves sur Google. Lisez leurs avis vérifiés, ils parlent mieux de nous que nous.
            </p>
            <span className="inline-flex items-center gap-1.5 text-sm font-bold mt-5 underline underline-offset-4 decoration-violet-400">
              Voir notre fiche Google
            </span>
          </motion.a>
        </Reveal>

        <Reveal delay={0.16} className="h-full">
          <motion.div
            whileHover={{ y: -5 }}
            transition={{ duration: 0.25 }}
            data-testid="comparatif-local-card"
            className="h-full rounded-2xl bg-white border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-7 text-center md:text-left"
          >
            <div className="w-11 h-11 rounded-xl bg-violet-100 flex items-center justify-center mx-auto md:mx-0">
              <MapPin size={20} className="text-violet-700" />
            </div>
            <h3 className="font-heading font-bold text-slate-900 text-lg mt-4">100% local, 100% disponible</h3>
            <p className="text-sm text-slate-500 leading-relaxed mt-2">
              En plein centre de Chatou, à 5 minutes de la gare RER A. Vos leçons partent de l'agence ou de chez vous,
              sur les vrais parcours d'examen des Yvelines.
            </p>
          </motion.div>
        </Reveal>
      </div>
    </div>
  </section>
);
